import React from 'react';
import ActivationContainer from '../containers/activation_container';

const ActivationContext = React.createContext(new ActivationContainer());

export default ActivationContext;
